<template>
    <v-dialog v-model="dialog" max-width="1000" style="background-color: red;" v-resize="onResize">
        <v-card v-if="isReady" class="standard-row pt-2 pl-10 pb-7"
            style="border: 1px solid #000000; border-radius: 20px;">
            <v-card-title class="pa-0">
                <v-row no-gutters class="standard-row justify-end"
                    style="width: 100%; font-size: 12px; padding: 9px 14px 9px 0px;">
                    <div v-if="permissionBtnEditMode">
                        <v-btn v-if="!editFile" rounded color="#fb8c00"
                            class="font-theme white--text download-report-Item-btn" @click="editFileData">
                            <v-icon class="mr-1">mdi-pen</v-icon> แก้ไขข้อมูล
                        </v-btn>
                        <v-btn v-if="editFile" rounded color="red" :disabled="loadingAddItem === true"
                            class="mr-3 font-theme white--text download-report-Item-btn" @click="cancelEdit">
                            <v-icon class="mr-1">mdi-close</v-icon> ยกเลิก
                        </v-btn>

                        <v-btn v-if="editFile" rounded color="green" :loading="loadingAddItem"
                            class="font-theme white--text download-report-Item-btn" @click="saveEditItem">
                            <v-icon class="mr-1">mdi-content-save</v-icon> บันทึก
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>
            <div class="scroll-theme add-Item-detail-scroll">
                <v-form lazy-validation ref="headerForm">
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">ITEM</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(field, title, index) in detailItem.Item" :key="`title_${index}`" cols="12"
                                sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="6" lg="6" style="font-weight: 700;">
                                        <v-icon v-show="windowSize.x < 960" size="15">mdi-play</v-icon> {{ title }}
                                    </v-col>
                                    <v-col v-if="!editFile" cols="12" sm="12" md="6" lg="6" class="pr-5">
                                        <span v-show="windowSize.x < 960">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        {{ dataInputs[field] || '-' }}
                                    </v-col>
                                    <v-col v-else cols="12" sm="12" md="6" lg="6" class="pr-5">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[field]"
                                            type="text" color="black" :rules="textRules" required
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc" />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                </v-form>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
export default {
    data: () => ({
        dialog: false,
         textRules: [v => !!v],
        loadingAddItem: false,
        originalDataInputs: {},
        isReady: false,
        editFile: false,
        permissionEdit:false,
        windowSize: { x: 0 },
    }),
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.editFile = false;
                this.dialog = false;
            }
        }
    },
    computed: {
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
        permissionBtnEditMode(){
         return this.$store.state.permissionBtnEditMode
        }
    },
    mounted() {
        EventBus.$on('openDetailItem', this.openDialog)
    },
    beforeDestroy() {
        EventBus.$off('openDetailItem')
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        openDialog(item) {
            this.item_id = item._id
            this.dialog = true
            this.isReady = true
            this.detailItem = {
                Item: {
                    'Material Code': 'material_code',
                    'Material Name': 'material_name',
                    'Objective Code': 'objective_code',
                    'Objective Name': 'objective_name',
                    'GL Account': 'gl_account',
                    'GL Account Name': 'gl_account_name',
                }
            };

            this.dataInputs = {
                material_code: item.material_code,
                material_name: item.material_name,
                objective_code: item.objective_code,
                objective_name: item.objective_name,
                gl_account: item.gl_account,
                gl_account_name: item.gl_account_name,
                tax_id: this.selectedBiz.tax_id
            };
            this.originalDataInputs = JSON.parse(JSON.stringify(this.dataInputs));

        },
        async saveEditItem() {
            if (!this.$refs.headerForm.validate()) return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            this.loadingAddItem = true;
            try {
                const { data } = await this.axios.put(`${this.$api_url}/item_erp/api/v1/edit_itemerp/${this.item_id}`, this.dataInputs)
                if (data.status) {
                    this.dialog = false;
                        this.editFile = false;
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                        setTimeout(() => {
                            EventBus.$emit('reloadItemPage');
                        }, 1000);
                } else {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                console.log(error);
            } finally {
                this.loadingAddItem = false;
            }
        },
        editFileData() {
            this.editFile = true
        },
        cancelEdit() {
            this.dataInputs = JSON.parse(JSON.stringify(this.originalDataInputs));
            this.editFile = false;
        },

        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    }
}
</script>

<style>
.Item-detail-scroll {
    overflow-y: auto;
    border-radius: 0px !important;
    max-height: calc(100vh - 158px);
}

.custom-text-field {
    width: 100%;
}



@media only screen and (max-width: 600px) {
    .Item-detail-scroll {
        max-height: calc(100vh - 238px) !important;
    }
}
</style>